import type { RefObject } from "react";
import type { AskUserQuestionAnswer, Message } from "../../api/types.js";
import { AskUserQuestionCard } from "./AskUserQuestionCard.js";

export function AskQuestionDock({
  askDockRef,
  pendingAskMessage,
  running,
  onSubmit,
  onCancel
}: {
  askDockRef: RefObject<HTMLDivElement | null>;
  pendingAskMessage: Message | null;
  running: boolean;
  onSubmit: (message: Message, answers: AskUserQuestionAnswer[]) => void;
  onCancel: (message: Message) => void;
}) {
  if (!pendingAskMessage?.meta?.askUserQuestion) return null;

  return (
    <div className="ask-user-question-dock" data-ask-user-question-dock ref={askDockRef}>
      <AskUserQuestionCard
        key={pendingAskMessage.id}
        ask={pendingAskMessage.meta.askUserQuestion}
        status="pending"
        disabled={running}
        onSubmit={(answers) => onSubmit(pendingAskMessage, answers)}
        onCancel={() => onCancel(pendingAskMessage)}
      />
    </div>
  );
}
